<div class="product-item">
  <button type="button" class="btn-remove-product" title="{{ 'productComparator.removeProduct' | cxTranslate }}" (click)="remove()">
    <span class="material-symbols-outlined d-flex"> close </span>
  </button>

  <div class="box-image">
    <product-media [product]="product" [urlTarget]="TARGET_TYPE.SELF"></product-media>
  </div>

  <div class="details">
    <p>
      <span class="title m-r-4">{{ 'productComparator.catalogNumber' | cxTranslate }}:</span>
      <span class="value">{{ product.catalogNumber }}</span>
    </p>

    <p>
      <span class="title m-r-4">{{ 'productComparator.partNumber' | cxTranslate }}:</span>
      <span class="value">{{ product.partNumber }}</span>
    </p>
  </div>
</div>